<div class="kis-file-upload"
     (kisDropZone)="upload.emit($event)">
  <ng-content></ng-content>
  <label *ngIf="!loading" for="upload-input" class="upload-button"> Choose Files </label>
  <input type="file" id="upload-input" (change)="upload.emit($event.target['files'])">
  <mat-spinner *ngIf="loading"></mat-spinner>
</div>
